export default [
  {
    name: 'project_description',
    component_path: 'modules/templates/blocks/project/ProjectDescription'
  }
]